import React, { useState, useEffect } from "react";
import { Row, Col, Button, Card, Table, ButtonGroup, Alert, ProgressBar, Badge, Tabs, Tab } from "react-bootstrap";
import moment from "moment";
import _ from "lodash";
import axios from "axios";
import Utils from "./../../common/Utils";

const AttnRequests = (props) => {
  
  const [teamRequests, setTeamRequests] = useState({
    loading: false,
    total: 0,
    start: 0,
    pp: Utils.perpage,
    records: [],
  });

  const [tab, setTab] = useState(1);

  const fetchTeamRequests = (start = 0) => {
    setTeamRequests({ ...teamRequests, loading: true });
    axios
      .get(Utils.apiUrl("attendence/fetchteamrequests") + `?tab=${tab}&st=${teamRequests.start}&pp=${teamRequests.pp}`, Utils.apiHeaders())
      .then((res) => {
        console.log(res);
        if (res.data.success) {
          setTeamRequests({
            ...teamRequests,
            loading: false,
            start:  start,
            total: _.get(res, "data.total", 0),
            records: _.get(res,'data.records',[]),
          });
        }
      })
      .catch((err) => {
        setTeamRequests({ ...teamRequests, loading: false });
        console.log(err);
      });
  };

  useEffect(fetchTeamRequests,[tab]);

  const addressRequest = (rid, aid) => (e) => {
    if (window.confirm(`You are going to ${aid === 0 ? "Disapprove" : "Approve"} this request, Continue?`)) {
      setTeamRequests({ ...teamRequests, loading: true });
      axios
        .post(Utils.apiUrl("attendence/updaterequest"), `rid=${rid}&aid=${aid}`, Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            fetchTeamRequests(0);
          } else {
            window.alert(res.data.message);
            setTeamRequests({ ...teamRequests, loading: false });
          }
        })
        .catch((err) => {
          setTeamRequests({ ...teamRequests, loading: false });
          console.log(err);
        });
    }
  };

  const showPagination = ({ loading, start, total }, callback) => {
    if (loading || (start === 0 && start + teamRequests.pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {start + teamRequests.pp >= total && (
            <div className="text-disabled ms-2">
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
            </div>
          )}
          {start + teamRequests.pp < total && (
            <div className="clickable ms-2 text-clickable" onClick={() => callback(start + teamRequests.pp)}>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
            </div>
          )}
          {start >= teamRequests.pp && (
            <div className="clickable text-clickable" onClick={() => callback(start - teamRequests.pp)}>
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
            </div>
          )}
          {start === 0 && (
            <div className="text-disabled">
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
            </div>
          )}
        </div>
      );
    }
  };
  
  return <>
    <h3 className="title mt-5 mb-4">My Team's Differed Attendance Requests</h3>
    <Card border="light" className="shadow table-section p-sm-0 p-lg-3">
      <Card.Body>
        {teamRequests.loading && (
          <Alert variant="success" className="p-3">
            <p className="loading-msg">Fetching Team's Differed Attendance requests.. </p>
            <ProgressBar variant="success" animated now={100} />
          </Alert>
        )}
        {!teamRequests.loading && (
          <>
            <Row className="m-0 p-0">
              <Col>
                <Tabs activeKey={tab} onSelect={(k) => setTab(parseInt(k))} className="mb-3">
                  <Tab eventKey="1" title="New Requests"></Tab>
                  <Tab eventKey="2" title="Delete Requests"></Tab>
                </Tabs>
              </Col>
            </Row>



            {teamRequests.records.length === 0 && <Alert variant="warning">No Differed Attendance found!</Alert>}

            {teamRequests.records.length > 0 && (
              <Table striped hover responsive className="text-nowrap">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Applicant</th>
                    <th>Date</th>
                    <th>Duration</th>
                    <th>Type</th>
                    <th>Reason</th>
                    <th style={{width: "180px"}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {teamRequests.records.map((rec, idx) => (
                    <tr key={rec.id}>
                      <td>
                        <span className="tb-lable tb-lable-warning">{Utils.addZero(teamRequests.start + idx + 1)}.</span>
                      </td>
                      <td>{rec.uname}</td>
                      <td>{moment(rec.logout).format("DD MMM, YY")}</td>
                      <td>{rec.duration}</td>
                      <td>{rec.diftype}</td>
                      <td>{rec.reason}</td>
                      <td>
                        {/*<img src={`${process.env.PUBLIC_URL}/images/calendar.png`} />*/}
                        <span className="btn btn-outline-success btn-sm ms-1" onClick={addressRequest(rec.id, 1)}>
                          Approve
                        </span>
                        <span className="btn btn-outline-secondary btn-sm ms-2" onClick={addressRequest(rec.id, 0)}>
                          Disapprove
                        </span>
                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
        {showPagination(teamRequests, fetchTeamRequests)}
      </Card.Body>
    </Card>   
  </> 
};

export default AttnRequests;